export const FIND_TABLE_COLUMNS_CONFIG_FOR_USER_FAILURE = 'FIND_TABLE_COLUMNS_CONFIG_FOR_USER_FAILURE';

export const findTableColumnsConfigForUserFailure = error => ({
    type: FIND_TABLE_COLUMNS_CONFIG_FOR_USER_FAILURE,
    payload: error,
    error: true,
});
